import { Badge } from '../ui/badge';
import { MarketStatus } from '@/libs/sdk/api';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type BadgeStatusProps = {
  deadline: number | string; // seconds
  status: MarketStatus;
};
export const BadgeStatus = ({ deadline, status }: BadgeStatusProps) => {
  const { t } = useTranslation();
  const isExpire = useMemo(() => Number(deadline) <= Math.ceil(Date.now() / 1e3), [deadline]);
  if (!isExpire && status === MarketStatus.progress) return null;
  return (
    <Badge variant="outline" className="text-[10px] !rounded-2 px-1">
      {isExpire && status === MarketStatus.progress && t('closed')}
      {status === MarketStatus.disputed && t('disputed')}
      {status === MarketStatus.settlement && t('settlement')}
      {status === MarketStatus.closed && t('resolved')}
    </Badge>
  );
};
